import {Avatar} from '@/components/ui/avatar/Avatar'
import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {XCloseIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {
    StyledTeamMemberSelectionData,
    StyledTeamMemberSelectionName
} from '@/features/agenda/components/agenda-event-form/agenda-event-team-member-selection/style'
import {TeamMember} from '@/features/treatment-requests/teams/types'
import {teamGroupToLabel} from '@/features/treatment-requests/teams/utils'
import {useTranslation} from '@/translations/i18n'

export const AgendaEventTeamMemberSelection = ({
    teamMember,
    onRemove
}: {
    teamMember: Pick<TeamMember, 'id' | 'group' | 'user'>
    onRemove: () => void
}) => {
    const {t} = useTranslation()

    return (
        <Flexbox gap={2} fullWidth align="center">
            <Avatar name={teamMember.user.fullName} size={'xs'} />
            <StyledTeamMemberSelectionData align="center" gap={2} fullWidth>
                <StyledTeamMemberSelectionName size="textSm" weight="500">
                    {teamMember.user.fullName}
                </StyledTeamMemberSelectionName>
                <Text size="textXs" palette="neutral" shade="500">
                    ({t(teamGroupToLabel[teamMember.group])})
                </Text>
            </StyledTeamMemberSelectionData>
            <Button variant="ghost" size="xs" onClick={onRemove}>
                <XCloseIcon />
            </Button>
        </Flexbox>
    )
}
